
import { Vue, Component, Prop } from "vue-property-decorator";
@Component({
  name: "TitleHeader",
  components: {},
})
export default class TitleHeader extends Vue {
  @Prop({ type: Array, required: false }) btnList?: any;
  @Prop({ type: Number }) active?: any;
  handleClickBtn(index: any) {
    this.$emit("handleClickBtn", index);
  }
  handleClickMore() {
    this.$emit("handleClickMore");
  }
}
